import React, { useEffect, useState } from 'react';
import './Footer.css';

const Footer = () => {
    return (
        <footer className="footer">
            <h4>Developed by Mert Koçak</h4>
        </footer>
    );
};

export default Footer;
